goog.provide('el8.uiwidget.multilist');

goog.require('el8.uiwidget.NewMindreader');
goog.require('el8.uiwidget.multilistEntry');
goog.require('el8.util.string');


/**
 * This widget manages a list of lists. Basically, it's a listeditor with sub-bullets.
 * It is currently (10/15) used exclusively by the VisitNote.
 */
el8.uiwidget.multilist = function(opts) {
    this._opts = opts || {};
};

el8.uiwidget.multilist.prototype.init = function(infoField) {

    // Pass in an already formed infoField for our first entry
    this.infoField = infoField;

    /**
     * Set all the options
     */
    this.$listContainer = this._opts.list;
    this.entryHeight = this._opts.entryHeight || 16;
    this.entryWidth = this._opts.entryWidth || null;
    this.infoText = this._opts.infoText || 'Add new item here';
    this.isNumbered = (this._opts.isNumbered !== false); // defaults to true
    this.isSortable = (this._opts.isSortable === true); // defaults to false
    this.labelIfEmpty = this._opts.labelIfEmpty || null;

    this.parentTriggerMap = this._opts.parentTriggerMap || null;
    this.childTriggerMap = this._opts.childTriggerMap || null;

    this.getParentItemTriggerFn = this._opts.getParentItemTriggerFn || function() { return ''; };
    this.getChildItemTriggerFn = this._opts.getChildItemTriggerFn || null;

    // function to evaluate whether we'd apply permanent highlight to a parent item
    // currently used only for fields modified by exporting visit note template
    this.shouldParentHighlightFn = this._opts.shouldParentHighlightFn || function() { return false; };

    this.parentSaveFn = this._opts.parentSaveFn || function() {};
    this.parentRemoveFn = this._opts.parentRemoveFn || function() {};

    // We're going to edit these below. If we don't clone beforehand, when we
    // add a wrapper function to the selectFn, we'll build a nested layer of wrappers
    this.mindreaderOpts = this._opts.mindreaderOpts ? _.clone(this._opts.mindreaderOpts) : null;

    this.listeditorOpts = this._opts.listeditorOpts || null;
    // Note: nothing is currently using these sublistMindreaderOpts,
    // so consider this an untested option
    this.sublistMindreaderOpts = this._opts.sublistMindreaderOpts || null;

    this.childSaveFn = this._opts.childSaveFn || null;
    // May need to generate saveChildFn because don't have parent ID yet
    this.genChildSaveFn = this._opts.genChildSaveFn || function() {};

    this.childRemoveFn = this._opts.childRemoveFn || null;
    // May need to generate saveChildFn because don't have parent ID yet
    this.genChildRemoveFn = this._opts.genChildRemoveFn || function() {};

    // sortSaveFn takes an array of id's as an argument
    this.sortSaveFn = this._opts.sortSaveFn || function() {};

    this.getItemTextFn = this._opts.getItemTextFn || function(obj) { return obj || ''; };
    this.getItemIdFn = this._opts.getItemIdFn || null;
    this.getChildrenFn = this._opts.getChildrenFn; // required

    // Can be used to render an uneditable text section
    // beneath each ML entry that represents coded data
    // attached to the entry (e.g., DX codes on an assessment bullet)
    this.getItemAnnotationFn = this._opts.getItemAnnotationFn || null;

    /**
     * Rest of initialization
     */
    // State variables
    this.entries = []; // ordered array of multilistEntry objects

    this.activeIndex = -1;
    this.$activeEntry = null;

    var that = this;

    /**
     * Initialize UI
     */
    this.$listContainer.addClass('ml-list');

    // Fill out input area
    // XSS OK -KF
    var inputArea = $('<div class="ml-inputarea el8EditorTextareaWrap">');
    this.$input = this.infoField.getInputField()
                    .addClass('ml-input');
    this.$input.wrap(inputArea);
    this.$input.parent().wrap($('<div class="ml-input-container el8FieldShortLabelPadding">'));
    this.$inputLabel = $('<label class="el8label ml-input-label el8EditorLabel">');
    this.$input.parent().before(this.$inputLabel);
    this.$input.height(this.entryHeight); //.width(this.$input.parent().width());

    this._updateInputLabel();

    if (this.mindreaderOpts) {
        /* The default blur handler is usually fired twice with the mindreader:
         * once when clicking on the MR and once when the value from the MR is entered.
         * This yields two entries (e.g., "ck" and "CKD - chronic kidney disease").
         * So we turn off that listener for MRs and instead run that code at the end
         * of the selectFn manually
         *
         * This introduces challenges when the user clicks/tabs off _without_ selecting
         * an MR entry. We hack around that by disabling the default blur handlers
         * whenever an MR is open and then having a special function run if the MR
         * is open but nothing is selected from it (multilistClickOffFn).
         */
        var origSelectFn = this.mindreaderOpts['selectFn'];
        this.mindreaderOpts['selectFn'] = function(e, selectedItem, mr) {
            if (mr.$inputField.hasClass('ml-parentedit')) {
                // editing an existing entry
                var entry = that.entries[that._getIndex(mr.$inputField)];
                if (origSelectFn) { origSelectFn(e, selectedItem, mr, entry); }

            } else {
                // the input at the bottom
                if (origSelectFn) { origSelectFn(e, selectedItem, mr, null); }
            }
        };
        this.mindreaderOpts['multilistClickOffFn'] = function(mr) {
            // this just copies code from the two 'blur' handlers below
            if (mr.$inputField.hasClass('ml-parentedit')) {
                var entry = that.entries[that._getIndex(mr.$inputField)];
                if (entry && entry.isParentActive()) {
                    entry._displayParentInput(); // will save
                }
            } else {
                that.selectEntry(null, true);
            }
        };

        // Instantiates and initializes the Legacy Mindreader on all applicable inputs
        this.mindreader = new el8.uiwidget.NewMindreader(this.mindreaderOpts);
        this.mindreader.init(this.$input);

        /**
         * Logic for rendering `BillDxNavMindreader` if the `BillDxNavigator` feature flag is enabled
         * Renders `BillDxNavMindreader` in the "Assessment/Plan" section of the 1-column, 2-column A/P, and Pre-Op VN
         * Renders `BillDxNavMindreader` in the "Assessment" section of the 2-column VN and VN Template
         * Hides the Legacy Mindreader parent element (MR input) for the last item in the 'ml-list' class
         * and renders the `BillDxNavMindreader` in its place
         *
         * FUTURE: Enable `BillDxNavMindreader` for editing existing assessment list items
         * Currently, editing an existing assessment list item will utilize the Legacy Mindreader
         */
        // Visit note list container IDs for targetting & mounting the BillDxNavMindreader container
        var isAssessmentContainer = this.$listContainer.length && this.$listContainer[0].id === 'visit-note-list-assessment'
        var isAssessPlanContainer = this.$listContainer.length && this.$listContainer[0].id === 'visit-note-list-assessplan'
        if (el8Globals.FEATURES.BillDxNavigator && (isAssessmentContainer || isAssessPlanContainer)) {
            // Used to generate unique IDs for the BillDxNavMindreader container
            // Required to enable multiple instances of BillDxNavMindreader to be mounted simultaneously
            var dxNavContainerIdSuffix = new Date()
            var dxNavContainerId = "vn-dx-nav-container-" + dxNavContainerIdSuffix.toISOString();
            var dxNavMindreaderContainer = "<div id=" + "'" + dxNavContainerId + "'" + ">";
            // Mounts a container for BillDxNavMindreader
            this.$input.parent().after($(dxNavMindreaderContainer));
            // Hides the Legacy mindreader input element
            this.$input.parent().hide();
            // Shared props for BillDxNavMindreader, null values are overwritten in the if statements below
            var dxNavMindreaderProps = {
                'data-testid': '',
                onSelect: function(item) {
                    if (origSelectFn && item) {
                        origSelectFn(null, item);
                    }
                },
                placeholder: '',
                showActiveImo: true,
            }
            // Configures BillDxNavMindreader props for mounting in the "Assessment" section of the 2-column VN and VN Template
            if (isAssessmentContainer) {
                dxNavMindreaderProps['data-testid'] = 'vn-assessment-dx-nav-input';
                dxNavMindreaderProps.placeholder = 'assessment...';
            }
            // Configures BillDxNavMindreader props for mounting in the "Assessment/Plan" section of the 1-column, 2-column A/P, and Pre-Op VN
            if (isAssessPlanContainer) {
                // Reassigning the onEnterFreeText function from imoMindreaderOptsFn to make it callable
                var selectFreeTextFn = this.mindreaderOpts['selectFreeTextFn']
                dxNavMindreaderProps['data-testid'] = 'vn-assessplan-dx-nav-input';
                if (selectFreeTextFn) {
                    dxNavMindreaderProps.allowFreeText = true;
                    dxNavMindreaderProps.onEnterFreeText = selectFreeTextFn;
                }
                dxNavMindreaderProps.placeholder = 'assessment/plan...';
            }
            // Renders BillDxNavMindreader in place of the Legacy mindreader input element
            el8React.render.billDxNavMindreader(dxNavContainerId, dxNavMindreaderProps);
        }
    }

    var that = this;
    this.$input.on('keydown', function(e) {
        switch(e.keyCode) {
            case KEYS.ENTER:
                if (e.shiftKey) { return; }
                e.preventDefault();
                var val = that.infoField.getVal();

                // If no mindreader, or mindreader not showing
                if (!that.mindreader ||
                   (that.mindreader && !that.mindreader.isShown)) {
                    that.selectEntry('activate');

                // Otherwise if have a mindreader showing, select result
                } else {
                    that.mindreader.selectActiveResult(e);
                    if (!that._opts.mindreaderOpts['stickyListInput'] ||
                            $(this).val() === val) {
                        that.selectEntry('activate');
                        that.mindreader.hide();
                    }
                }
                // If no mindreader, stop event here
                if (!that.mindreaderOpts){
                    return false;
                }
                break;

            case KEYS.TAB:
                var val = that.infoField.getVal();
                that.selectEntry();

                if (that.mindreader) {
                    that.mindreader.hide();
                }

                if (e.shiftKey) {
                    var moved = val ? that.shiftTabByOffset(2) : that.shiftTabByOffset(1);
                    if (moved) { return false; }

                } else {
                    if (val) {
                        $(this).scrollintoview().focusFocus();
                        return false;
                    }
                }

                break;

            default:
                break;
        }
    }).on('focus', function() {
        that._deactivateAllEntries();

        // if the MR was bound to one of the ml-parentedits, we need
        // to initialize it to point to the input again
        if (that.mindreader && that.mindreader.$inputField[0] !== this) {
            that.mindreader.hide();
            that.mindreader.init($(this));
        }
    });

    // See the mindreaderOpts above for an explanation
    // of why we don't use selectEntry with the mindreader
    this.$input.on('blur', function(e) {
        if (that.mindreader && that.mindreader.isShown) {
            return; // multilistClickOffFn will handle this
        }
        that.selectEntry(null, true);
    });

    var $container = $(this.$listContainer[0]);

    $container.on('keydown', '.ml-parentedit', function(e) {
        if(e.keyCode === KEYS.ENTER) {
            if (e.shiftKey) return;

            e.preventDefault();

            if (!that.mindreader ||
               (that.mindreader && !that.mindreader.isShown)) {
                var entry = that.entries[that._getIndex($(this))];
                entry && entry.activateSublist();
            } else {
                var value = $(this).val();
                that.mindreader.selectActiveResult(e);
                that.mindreader.hide();

                // Sticky list input lets you edit the line some more even after mindreader selects
                if (!that._opts.mindreaderOpts['stickyListInput'] || $(this).val() === value) {
                    var entry = that.entries[that._getIndex($(this))];
                    entry && entry.activateSublist();
                }
            }
        }
    });
    $container.on('blur', '.ml-parentedit', function(event) {
        if (that.mindreader && that.mindreader.isShown) {
            return; // multilistClickOffFn will handle this
        }
        var entry = that.entries[that._getIndex($(this))];
        if (entry && entry.isParentActive()) {
            entry._displayParentInput(); // will save
        }
    });

    if (this.parentTriggerMap) {
        $container.on('click', '.ml-trigger', function(e) {
            var name = $(this).attr('name');
            var entry = that.entries[that._getIndex($(this))];
            var removeTriggerFn = function() {
                entry.removeParentTrigger();
            };
            var entryMap = entry.getEntryAsMap();
            var getTextFn = function(a) { return a.text; };
            that.parentTriggerMap[name](
                entryMap['parentObj']['id'],
                entryMap['parentObj']['text'],
                entryMap['children'].map(getTextFn),
                removeTriggerFn,
                $(this));
            return false;
        });
    }

    $container.on('click', '.ml-remove-trigger', function(e) {
        var entry = that.entries[that._getIndex($(this))];
        that.removeEntry(entry);
    });

    $container.on('focus', '.ml-parentedit', function(e) {
        that._deactivateAllEntries();

        var entry = that.entries[that._getIndex($(this))];
        entry._editParentInput();
        // if the MR was bound to another ml-parentedit or the input,
        // we need to initialize it to point here
        if (that.mindreader && that.mindreader.$inputField[0] !== entry.getParentInput()[0]) {
            that.mindreader.init(entry.getParentInput());
        }
        if (that.mindreader) {that.mindreader.init(entry.getParentInput());}
    });
    $container.on('keydown', ':input', function(e) {
        if(e.keyCode === KEYS.TAB) {
            var index = that._getIndex($(this));
            var entry = that.getNthEntry(index);

            if (!e.shiftKey) {
                if (entry.hasSublist() && !$(this).hasClass('le-input')) {
                    entry.activateEntryBottom();
                    return false;
                } else if (that._isLastEntry($(this))) {
                    that.infoField.getInputField().focusFocus();
                    return false;
                } else {
                    var index = that._getIndex($(this));
                    if ($(this).hasClass('le-input')) {
                        var nextEntry = that.getNthEntry(index + 1);
                        nextEntry.activateParentInput();
                    } else {
                        that.activateNext(index);
                    }
                    return false;
                }

            } else {
                var index = that._getIndex($(this));
                if ($(this).hasClass('le-input')) {
                    entry.activateParentInput();
                    return false;

                } else if (!that._isFirstEntry($(this))) {
                    var newEntry = that.getNthEntry(index - 1);
                    newEntry.activateEntryBottom();
                    return false;
                }
            }
        }
    });

    if (this.isSortable) {
        this.$listContainer.sortable({
            handle: '.ml-sort',
            items: 'li.ml-entry',
            cursor: 'move',
            update: function(event, ui) {
                // For some reason in Firefox the blurring doesn't happen so we do manually.
                if (ui && ui.item) { $(':input', ui.item).blur(); }

                that._recalcIndexes();
                if (that.sortSaveFn) {
                    var ids = [];
                    for (var i=0; i<that.entries.length; i++) {
                        ids.push(that.entries[i].getParentId());
                    }
                    that.sortSaveFn(ids);
                }
            }
        });
    }

    return this;
};


el8.uiwidget.multilist.prototype.shiftTabByOffset = function(offset) {
    var index = this.numEntries() - offset;
    if (index >= 0) {
        var entry = this.getNthEntry(index);
        entry.activateEntryBottom();
        return true;
    }
    return false;
};

el8.uiwidget.multilist.prototype.selectEntry = function(sublistAction, async) {
    var val = this.infoField.getVal();
    if (val) {
        val = el8.util.string.cleanMultiByteChars(val);
        this.infoField.setVal('');
        this.$input.height(this.entryHeight);
        var entry = this._createEntry();
        this._populateEntryParent(entry, val, false, true, async);
        if (sublistAction === 'activate') { entry.activateSublist(); }
        else if (sublistAction === 'init') { entry.initSublist(); }
    }
};

el8.uiwidget.multilist.prototype.addEntry = function(parentItem, doHighlight, doSave, async, asClean) {
    var entry = this._createEntry();
    this._populateEntryParent(entry, parentItem, doHighlight, (doSave === true), (async === true));
    // Always init sublist
    var childItems = this.getChildrenFn(parentItem);
    if (childItems.length) {
        entry.initSublist();
        this.addEntryChildren(entry, childItems, doHighlight, async, asClean);
    }
    return entry;
};


el8.uiwidget.multilist.prototype.addEntryAsClean = function(item, doHighlight, doSave, async) {
    // Wraps the above which creates a new "entry" (a "parent obj" with a list editor with "children")
    // We want the entry to be marked as clean at this point, which means saving the parent's
    // id and text in the entry. This is now done by the entry.setParentInputVal() called above.
    //
    // The children/LE items are marked as clean as well with the asClean flag above
    this.addEntry(item, doHighlight, doSave, async, true);
};

el8.uiwidget.multilist.prototype._createEntry = function() {
    var that = this;
    var entry = new el8.uiwidget.multilistEntry({
        isNumbered: this.isNumbered,
        isSortable: this.isSortable,
        index: this.numEntries(),
        entryHeight: this.entryHeight,
        entryWidth: this.entryWidth,
        getItemIdFn: this.getItemIdFn,
        getItemTextFn: this.getItemTextFn,
        getItemAnnotationFn: this.getItemAnnotationFn,
        parentSaveFn: this.parentSaveFn,
        parentRemoveFn: this.parentRemoveFn,
        destroyFn: function(mlEntry) {
            var index = mlEntry.getIndex();
            that.entries.splice(index, 1);
            that._recalcIndexes();
        },
        childSaveFn: this.childSaveFn,
        genChildSaveFn: this.genChildSaveFn,
        childRemoveFn: this.childRemoveFn,
        genChildRemoveFn: this.genChildRemoveFn,
        nextElt: this.$input,
        childTriggerMap: this.childTriggerMap,
        getChildItemTriggerFn: this.getChildItemTriggerFn,
        mindreaderOpts: this.sublistMindreaderOpts,
        listeditorOpts: this.listeditorOpts
    }).init(this.$listContainer);

    /* Set as nextElt appropriately */
    if (this.entries.length) {
        var priorEntry = this.entries[this.entries.length-1];
        priorEntry.setNextElt(entry.getParentInput());
    }

    this.entries.push(entry);
    this._updateInputLabel();

    return entry;
};

el8.uiwidget.multilist.prototype._populateEntryParent = function(entry, parentItem,
        doHighlight, doSave, async) {

    var parentVal = null,
        parentTriggerName = null,
        parentId = null,
        parentAnnotation = null,
        parentHighlight = null;
    if (typeof parentItem === 'string') {
        parentVal = parentItem;
        parentTriggerName = this.getParentItemTriggerFn(null);
    } else {
        parentVal = this.getItemTextFn(parentItem);
        parentId = this.getItemIdFn(parentItem);
        parentTriggerName = this.getParentItemTriggerFn(parentItem);
        if (this.getItemAnnotationFn) {
            parentAnnotation = this.getItemAnnotationFn(parentItem);
        }
        parentHighlight = this.shouldParentHighlightFn(parentItem);
    }
    if (parentId) { entry.setParentId(parentId); }

    entry.setParentInputVal(parentVal, {
        triggerName: parentTriggerName,
        annotationHtml: parentAnnotation,
        doHighlight: doHighlight,
        doSave: doSave,
        async: async
    });

    // permanent highlight, currently only used when field is populated by visit note template
    if (parentHighlight) {
        var $wrap = $('.le-entry', entry.$entryContainer);
        $wrap.addClass('el8BlueHighlight');
    }
};
el8.uiwidget.multilist.prototype.rerenderParent = function(entry, parentItem) {
    this._populateEntryParent(entry, parentItem, false, false, true);
};

el8.uiwidget.multilist.prototype.addEntryChild = function(entry, childItem, doHighlight, async) {
    if (!entry.hasSublist()) {
        entry.initSublist();
    }
    entry.getListeditor().addEntry(childItem, doHighlight, async);
};
el8.uiwidget.multilist.prototype.addEntryChildren = function(entry, childItems, doHighlight, async, asClean) {
    if (!entry.hasSublist()) {
        entry.initSublist();
    }

    if (asClean) {
        // Signal to the LE to add this "children" without making dirty
        entry.getListeditor().addEntriesAsClean(childItems, doHighlight, async);
    } else {
        entry.getListeditor().addEntries(childItems, doHighlight, async);
    }

};
el8.uiwidget.multilist.prototype.highlightEntryChild = function(entryIndex, childIndex) {
    var entry;
    if (!isNaN(entryIndex*1)) {
        entry = this.getNthEntry(entryIndex);
    } else {
        entry = entryIndex;
    }
    if (!entry.hasSublist()) { return; }
    var childEntry = entry.getListeditor().getNthEntry(childIndex);
    entry.getListeditor().highlightEntry(childEntry);
};

el8.uiwidget.multilist.prototype.addEntries = function(parentItems) {
    for (var i=0; i<parentItems.length; i++) {
        this.addEntry(parentItems[i]);
    }
};

el8.uiwidget.multilist.prototype.removeEntry = function(mlEntry) {
    mlEntry.destroy();
};

el8.uiwidget.multilist.prototype.getEntryObjs = function() {
    return this.entries;
};

el8.uiwidget.multilist.prototype.getAllEntries = function() {
    var result = [];
    for (var i=0; i<this.entries.length; i++) {
        result.push(this.entries[i].getEntryAsMap());
    }
    return result;
};

el8.uiwidget.multilist.prototype.getAllEntryChildren = function(entry) {
    if (!entry.hasSublist()) { return []; }
    return entry.getListeditor().getAllEntries();
};

el8.uiwidget.multilist.prototype.numEntries = function() {
    return $('li.ml-entry', this.$listContainer).length;
};

el8.uiwidget.multilist.prototype.getNthEntry = function(n) {
    var mod_n = n % this.numEntries();
    return this.entries[mod_n];
};
el8.uiwidget.multilist.prototype.getLastEntry = function() {
    return this.entries[this.numEntries() - 1];
};

el8.uiwidget.multilist.prototype.activateNext = function(index) {
    var newIndex = index + 1;
    if (newIndex < this.numEntries()) {
        var entry = this.getNthEntry(newIndex);
        entry.activateParentInput();
    } else {
        this.infoField.getInputField().scrollintoview().focusFocus();
    }
};

el8.uiwidget.multilist.prototype.activatePrev = function(index) {
    var newIndex = index - 1;
    if (newIndex < this.numEntries()) {
        var entry = this.getNthEntry(newIndex);
        entry.activateEntryBottom();
    }
};

el8.uiwidget.multilist.prototype.saveIfDirty = function() {
    for (var i=0; i<this.entries.length; i++) {
        this.entries[i].saveIfDirty();
    }
};

el8.uiwidget.multilist.prototype._recalcIndexes = function() {
    var that = this;
    var newEntries = [];
    // Update indexes for all the entries
    for (var i=0; i<that.entries.length; i++) {
        var entry = that.entries[i];
        var newIndex = entry.getEntryContainer().index();
        if (newIndex >= 0) {
            entry.setIndex(newIndex);
            newEntries[newIndex] = entry;
        }
    }
    // Then update the entries array
    that.entries = newEntries;
    this._updateInputLabel();
};

el8.uiwidget.multilist.prototype._getIndex = function($elt) {
    return $elt.closest('li.ml-entry').attr('_ml_index')*1;
};

el8.uiwidget.multilist.prototype._isLastEntry = function($elt) {
    return (this.numEntries() === (this._getIndex($elt)+1));
};

el8.uiwidget.multilist.prototype._isFirstEntry = function($elt) {
    return (0 === this._getIndex($elt));
};

el8.uiwidget.multilist.prototype._updateInputLabel = function() {
    if (this.labelIfEmpty && this.numEntries() === 0) {
        this.$inputLabel.text(this.labelIfEmpty);
    } else {
        this.$inputLabel.text(this.isNumbered ? this.numEntries() + 1+':' : '-');
    }
};

el8.uiwidget.multilist.prototype._deactivateAllEntries = function() {
    // This is a pretty lame hack. When you combine the blur/focus/click/keydown
    // listeners for the multlist, listeditor, and mindreader, bad things
    // sometimes happen... for multlist listeditors, that sometimes means
    // the previous entry is never de-selected before the next entry gets
    // focus... and that prevents the trigger from being clickable.
    $('.le-entry.active', this.$listContainer).removeClass('active');
};

el8.uiwidget.multilist.prototype.getJsonData = function() {
    if (this.entries && this.entries.length) {
        return _.map(this.entries, function(entry) {
            return entry.getEntryJsonData();
        });
    } else {
        return null;
    }
};
